<template>
    <div class="main">
        <c-panel title="QUADRO DE VAGAS" titleIcon="fas fa-chair">

            <el-alert type="info" :closable="false" class="u-mb-15"
                title="As vagas ocupadas são calculadas a partir das matrículas — não são digitadas. Use Recalcular para atualizá-las."
                description="A coluna Horas/aula do turno é onde se configura a carga de aulas de cada turno, por curso e etapa."></el-alert>

            <el-form label-position="top" @submit.native.prevent>
                <el-row :gutter="10" class="u-mb-15">
                    <el-col :xs="24" :sm="8">
                        <el-form-item label="Escola" class="u-mb-0">
                            <el-select v-model="instituicaoId" filterable style="width: 100%;" @change="carregar">
                                <el-option v-for="i in instituicoes" :key="i.id" :value="i.id" :label="i.nome"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :xs="24" :sm="6">
                        <el-form-item label="Período letivo" class="u-mb-0">
                            <el-select v-model="periodoId" style="width: 100%;" @change="carregar">
                                <el-option v-for="p in periodos" :key="p.id" :value="p.id" :label="p.nome"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :xs="24" :sm="10" class="u-text-right">
                        <el-button v-if="podeEscrever && pronto" size="small" icon="el-icon-refresh" @click="recalcular">RECALCULAR OCUPAÇÃO</el-button>
                        <el-button class="u-ml-10" v-if="podeEscrever && pronto" size="small" icon="el-icon-document-copy" @click="dialogoCopia = true">COPIAR DE OUTRO ANO</el-button>
                        <el-button class="u-ml-10" v-if="podeEscrever && pronto" size="small" type="primary" icon="el-icon-plus" @click="adicionar">NOVA LINHA</el-button>
                    </el-col>
                </el-row>
            </el-form>

            <el-row v-if="totais" :gutter="10" class="u-mb-15">
                <el-col :xs="24" :sm="6" :md="6"><div class="u-text-center"><h3 class="u-mb-0">{{ totais.vagas }}</h3><small>vagas totais</small></div></el-col>
                <el-col :xs="24" :sm="6" :md="6"><div class="u-text-center"><h3 class="u-mb-0">{{ totais.reservadas }}</h3><small>reservadas p/ inscrição</small></div></el-col>
                <el-col :xs="24" :sm="6" :md="6"><div class="u-text-center"><h3 class="u-mb-0">{{ totais.ocupadas }}</h3><small>ocupadas</small></div></el-col>
                <el-col :xs="24" :sm="6" :md="6"><div class="u-text-center"><h3 class="u-mb-0" :class="classeSaldo(totais.saldo, totais.vagas)">{{ totais.saldo }}</h3><small>saldo</small></div></el-col>
            </el-row>

            <div class="container-table" v-if="pronto">
                <table class="table table-striped">
                    <thead>
                        <tr>
                            <th style="width: 180px;">Curso / Série</th>
                            <th style="width: 140px;">Etapa da matriz</th>
                            <th style="width: 110px;">Turno</th>
                            <th style="width: 90px;">Vagas</th>
                            <th style="width: 110px;">Reservadas</th>
                            <th style="width: 90px;" class="u-text-center">Ocupadas</th>
                            <th style="width: 80px;" class="u-text-center">Saldo</th>
                            <!--
                                EDUCAÇÃO item 9 — "configuração de horas/aula por turno".
                                O rótulo curto "Horas/aula" não dizia a que se referia e o
                                campo passava despercebido; o `title` explica no hover.
                            -->
                            <th style="width: 130px;"
                                title="Quantidade de horas/aula do turno neste curso e etapa. Atende ao requisito de configuração de horas/aula por turno.">
                                Horas/aula do turno
                            </th>
                            <th style="width: 70px;" class="u-text-center">Ação</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(l, idx) in linhas" :key="idx">
                            <td>
                                <el-select v-model="l.curso_id" filterable clearable size="mini" placeholder="Todos" style="width: 100%;">
                                    <el-option v-for="c in cursos" :key="c.id" :value="c.id" :label="c.nome"></el-option>
                                </el-select>
                            </td>
                            <td>
                                <el-select v-model="l.matriz_etapa_id" filterable clearable size="mini" placeholder="—" style="width: 100%;">
                                    <el-option v-for="e in etapas" :key="e.id" :value="e.id" :label="e.nome"></el-option>
                                </el-select>
                            </td>
                            <td>
                                <el-select v-model="l.turno" size="mini" style="width: 100%;">
                                    <el-option v-for="t in turnos" :key="t.v" :value="t.v" :label="t.l"></el-option>
                                </el-select>
                            </td>
                            <td><el-input v-model="l.qtd_vagas_total" v-mask="'####'" size="mini"></el-input></td>
                            <td><el-input v-model="l.qtd_vagas_reservadas_inscricao" v-mask="'####'" size="mini"></el-input></td>
                            <td class="u-text-center">{{ l.qtd_vagas_ocupadas || 0 }}</td>
                            <td class="u-text-center">
                                <span :class="classeSaldo(saldoLinha(l), l.qtd_vagas_total)">{{ saldoLinha(l) }}</span>
                            </td>
                            <td>
                                <el-input v-model="l.qtd_horas_aula_turno" v-mask="'##'" size="mini"
                                    title="Horas/aula deste turno no curso e etapa da linha."></el-input>
                            </td>
                            <td class="u-text-center">
                                <el-button v-if="podeEscrever" @click="remover(idx)" type="danger" icon="el-icon-delete" size="mini" plain></el-button>
                            </td>
                        </tr>
                        <tr v-if="linhas.length === 0">
                            <td colspan="9" class="u-text-center">Nenhuma linha. Clique em "Nova linha" para montar o quadro.</td>
                        </tr>
                    </tbody>
                </table>
            </div>

            <div class="u-text-right u-mt-20" v-if="podeEscrever && pronto">
                <el-button type="primary" @click="salvar">SALVAR QUADRO</el-button>
            </div>

            <el-dialog title="Copiar quadro de vagas de outro período" :visible.sync="dialogoCopia" width="520px">
                <el-form label-position="top">
                    <el-alert type="info" :closable="false" class="u-mb-15"
                        title="As linhas que já existirem no período de destino são preservadas — copiar de novo não duplica nada."></el-alert>
                    <el-form-item label="Copiar do período">
                        <el-select v-model="periodoOrigem" style="width: 100%;">
                            <el-option v-for="p in periodos" :key="p.id" :value="p.id" :label="p.nome"></el-option>
                        </el-select>
                    </el-form-item>
                </el-form>
                <span slot="footer">
                    <el-button @click="dialogoCopia = false">CANCELAR</el-button>
                    <el-button class="u-ml-10" type="primary" @click="copiar">COPIAR</el-button>
                </span>
            </el-dialog>
        </c-panel>
    </div>
</template>
<script>
/**
 * BLOCO D — itens 44, 9 e 54. Interface para `api/quadro-vagas`.
 * A ocupação é derivada das matrículas pelo backend; a tela nunca a edita.
 */
import { periodosLetivosMixin } from '@/shared/periodos-letivos'
export default {
    mixins: [periodosLetivosMixin],
    data: () => ({
        pronto: false,
        instituicaoId: null, periodoId: null, periodoOrigem: null,
        instituicoes: [], cursos: [], etapas: [],
        linhas: [], totais: null,
        dialogoCopia: false,
        turnos: [{ v: 0, l: 'Matutino' }, { v: 1, l: 'Vespertino' }, { v: 2, l: 'Noturno' }, { v: 4, l: 'Integral' }]
    }),
    computed: {
        podeEscrever () { return [0, 1, 3, 4, 5, 6, 7, 9, 12].includes(parseInt(this.$store.state.user.tipo)) }
    },
    mounted () {
        this.periodoId = this.$store.state.config.periodo ? this.$store.state.config.periodo.id : null

        this.$axios.get(`${this.$store.state.config.baseUrlApi}/api/curso/getAllCurso`,
            this.$store.getters.getHeaderAuth
        ).then(r => { this.cursos = Array.isArray(r.data) ? r.data : [] }).catch(() => {})

        const inst = this.$store.state.config.instituicao
        if (inst && inst.id) {
            this.instituicoes = [inst]
            this.instituicaoId = inst.id
            this.carregar()
        } else {
            this.$axios.get(`${this.$store.state.config.baseUrlApi}/api/instituicao/getAll`,
                this.$store.getters.getHeaderAuth
            ).then(r => { this.instituicoes = Array.isArray(r.data) ? r.data : [] }).catch(() => {})
        }
    },
    methods: {
        carregar () {
            if (!this.instituicaoId || !this.periodoId) return
            this.pronto = false
            this.$axios.get(`${this.$store.state.config.baseUrlApi}/api/quadro-vagas/getByInstituicao/${this.instituicaoId}/${this.periodoId}`,
                this.$store.getters.getHeaderAuth
            ).then(r => {
                if (r.data && r.data.erro) {
                    window.eventBus.$emit('alert', { msg: this.textoErro(r.data.erro), type: 'warning' })
                    this.linhas = []; this.totais = null
                } else {
                    this.linhas = (r.data.itens || []).map(i => Object.assign({}, i))
                    this.totais = r.data.totais
                }
                this.pronto = true
            }).catch(e => this.$store.commit('throwException', e))
        },
        saldoLinha (l) { return (parseInt(l.qtd_vagas_total) || 0) - (parseInt(l.qtd_vagas_ocupadas) || 0) },
        classeSaldo (saldo, total) {
            const t = parseInt(total) || 0
            if (saldo <= 0) return 'saldo-vermelho'
            if (t > 0 && saldo <= t * 0.2) return 'saldo-amarelo'
            return 'saldo-verde'
        },
        adicionar () {
            this.linhas.push({ id: null, curso_id: null, matriz_etapa_id: null, turno: 0,
                qtd_vagas_total: 0, qtd_vagas_reservadas_inscricao: 0, qtd_vagas_ocupadas: 0, qtd_horas_aula_turno: null })
        },
        remover (idx) { this.linhas.splice(idx, 1) },
        salvar () {
            window.eventBus.$emit('loading', true)
            this.$axios.post(`${this.$store.state.config.baseUrlApi}/api/quadro-vagas/salvarLote`,
                { instituicao_id: this.instituicaoId, periodo_letivo_id: this.periodoId, itens: this.linhas },
                this.$store.getters.getHeaderAuth
            ).then(r => {
                window.eventBus.$emit('loading', false)
                if (r.data && r.data.erro) {
                    window.eventBus.$emit('alert', { msg: this.textoErro(r.data.erro), type: 'warning' })
                    return
                }
                window.eventBus.$emit('alert', { msg: r.data.mensagem || 'Quadro salvo.', type: 'success' })
                this.carregar()
            }).catch(e => { window.eventBus.$emit('loading', false); this.$store.commit('throwException', e) })
        },
        recalcular () {
            window.eventBus.$emit('loading', true)
            this.$axios.post(`${this.$store.state.config.baseUrlApi}/api/quadro-vagas/recalcularOcupacao/${this.periodoId}`,
                { instituicao_id: this.instituicaoId }, this.$store.getters.getHeaderAuth
            ).then(r => {
                window.eventBus.$emit('loading', false)
                if (r.data && r.data.erro) {
                    window.eventBus.$emit('alert', { msg: this.textoErro(r.data.erro), type: 'warning' })
                    return
                }
                window.eventBus.$emit('alert', { msg: r.data.mensagem, type: 'success' })
                this.carregar()
            }).catch(e => { window.eventBus.$emit('loading', false); this.$store.commit('throwException', e) })
        },
        copiar () {
            this.$axios.post(`${this.$store.state.config.baseUrlApi}/api/quadro-vagas/copiarDoAnoAnterior`,
                { periodo_origem_id: this.periodoOrigem, periodo_destino_id: this.periodoId, instituicao_id: this.instituicaoId },
                this.$store.getters.getHeaderAuth
            ).then(r => {
                if (r.data && r.data.erro) {
                    window.eventBus.$emit('alert', { msg: this.textoErro(r.data.erro), type: 'warning' })
                    return
                }
                window.eventBus.$emit('alert', { msg: r.data.mensagem + (r.data.aviso ? ' ' + r.data.aviso : ''), type: 'success' })
                this.dialogoCopia = false
                this.carregar()
            }).catch(e => this.$store.commit('throwException', e))
        },
        textoErro (e) { return typeof e === 'string' ? e : (e.text || 'Não foi possível concluir.') }
    }
}
</script>
<style scoped>
.saldo-verde { color: #2e7d32; font-weight: bold; }
.saldo-amarelo { color: #ef6c00; font-weight: bold; }
.saldo-vermelho { color: #c62828; font-weight: bold; }
</style>
